import { ListItem, ListItemText, Text } from "@clipboard-health/ui-components";
import { Box, Stack, type SxProps, type Theme } from "@mui/material";
import { type ReactNode } from "react";

interface LabeledListItemProps {
  divider?: boolean;
  label: ReactNode;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export function LabeledListItem({ divider, label, children, sx }: LabeledListItemProps) {
  return (
    <ListItem divider={divider} sx={sx}>
      <ListItemText
        disableTypography
        primary={
          <Stack direction="row" spacing={4} alignItems="flex-start">
            <Box sx={{ minWidth: "6rem", flexShrink: 0 }}>
              {typeof label === "string" ? (
                <Text semibold variant="h6">
                  {label}
                </Text>
              ) : (
                label
              )}
            </Box>
            <Stack spacing={2} flex={1}>
              {children}
            </Stack>
          </Stack>
        }
      />
    </ListItem>
  );
}
